import { cn } from '../../lib/cn';
import type { LifecycleRow } from '../../enterpriseaigovernance/framework';

type Props = { pipeline?: LifecycleRow[] };

export function AILifecyclePanel({ pipeline = [] }: Props) {
  const maxCount = Math.max(...pipeline.map((p) => p.count), 1);

  return (
    <div className="space-y-2">
      {pipeline.map((stage) => (
        <div key={stage.stage} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{stage.stage}</p>
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              stage.status === 'production' || stage.status === 'passed' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {stage.status}
            </span>
          </div>
          <div className="mt-2 flex items-center gap-3">
            <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
              <div className="h-full rounded-full bg-brand-500" style={{ width: `${(stage.count / maxCount) * 100}%` }} />
            </div>
            <span className="text-xs font-medium text-slate-600 dark:text-slate-400">{stage.count}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
